import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@/../environments/environment';
import { TipoCota, TipoCotaRequest } from '@/models';

@Injectable({
  providedIn: 'root',
})
export class TipoCotaService {
  private baseUrl = `${environment.apiUrl}/admin/tipos-cotas`;

  constructor(private http: HttpClient) {}

  getTiposCotas(): Observable<TipoCota[]> {
    return this.http.get<TipoCota[]>(this.baseUrl);
  }

  getTipoCota(id: number): Observable<TipoCota> {
    return this.http.get<TipoCota>(`${this.baseUrl}/${id}`);
  }

  createTipoCota(data: TipoCotaRequest): Observable<TipoCota> {
    return this.http.post<TipoCota>(this.baseUrl, data);
  }

  updateTipoCota(id: number, data: TipoCotaRequest): Observable<TipoCota> {
    return this.http.put<TipoCota>(`${this.baseUrl}/${id}`, data);
  }

  deleteTipoCota(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  toggleStatus(id: number, active: boolean): Observable<TipoCota> {
    return this.http.patch<TipoCota>(`${this.baseUrl}/${id}/toggle-status`, { active });
  }
}
